// Components==============
import React from 'react';
import { useSelector } from 'react-redux';
import BoomHut from 'screens/Login/Buildings/BoomHut';
import Camper from 'screens/Login/Buildings/Camper';
import Huis from 'screens/Login/Buildings/Huis';
import Kasteel from 'screens/Login/Buildings/Kasteel';
import LuchtBallon from 'screens/Login/Buildings/LuchtBallon';
import Rocket from 'screens/Login/Buildings/Rocket';
import Tent from 'screens/Login/Buildings/Tent';
import { Colors } from 'screens/Login/Login';
import './Avatar.module.scss';
import TrophyGarden from './TrophyGarden/TrophyGarden';
// =========================

export default function Avatar({ trophyGarden }: { trophyGarden?: boolean }) {
    const user = useSelector(
        (state: ReduxStore) => state?.authentication?.user
    );

    const groundPlane = user?.username?.split('_')[1];
    const buildingType = user?.username?.split('_')[2];
    const selectedColor = (user?.username?.split('_')[3] as Colors) || 'blue';

    return (
        <div styleName="wrapper">
            <div styleName="tile">
                <img
                    alt="isometic-tile"
                    styleName="ground-plane"
                    src={`/images/login/groundplanes/ondergrond-${groundPlane}.svg`}
                />
                <>
                    {buildingType === 'tent' && (
                        <Tent selectedColor={selectedColor} />
                    )}
                    {buildingType === 'huis' && (
                        <Huis selectedColor={selectedColor} />
                    )}
                    {buildingType === 'luchtballon' && (
                        <LuchtBallon selectedColor={selectedColor} />
                    )}
                    {buildingType === 'kasteel' && (
                        <Kasteel selectedColor={selectedColor} />
                    )}

                    {buildingType === 'boomhut' && (
                        <BoomHut selectedColor={selectedColor} />
                    )}
                    {buildingType === 'camper' && (
                        <Camper selectedColor={selectedColor} />
                    )}
                    {buildingType === 'raket' && (
                        <Rocket selectedColor={selectedColor} />
                    )}
                </>
            </div>
            {trophyGarden && <TrophyGarden />}
        </div>
    );
}
